import React, { useState, useEffect } from 'react';
import { Modal } from '@mui/material';
import { liveTrackinglayoutSelector } from '../../features/layout/layoutSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
    Paper, Typography, Divider, Grid, Button
} from '@mui/material';

import {
    fuelSetupSelector, getFuelSetup
} from '../../features/fueladmin/fuelSlice';
import { getAllVehiclesAsRack } from '../../features/assets/assetsSlice';
import { useridSelector } from '../../features/user/UserSlice';

import FuelLeftColumn from './FuelLeftColumn';
import FuelRightColumn from './FuelRightColumn';

const FuelMainModal = ({ fuelSetupOpen, handleFuelSetupClose, assetId }) => {
    const dispatch = useDispatch();
    const dimention = useSelector(liveTrackinglayoutSelector);
    const userid = useSelector(useridSelector);
    const rack = useSelector(getAllVehiclesAsRack);
    const assetData = rack[`${assetId}`];
    const regn = assetData && assetData.vehicleDevice.regn;

    const fuelSetupAll = useSelector(fuelSetupSelector);
    const fuelSetup = fuelSetupAll && fuelSetupAll[assetId];


    useEffect(() => {
        if (assetId && fuelSetupOpen) {
            dispatch(getFuelSetup({ assetId, userid }));
        }

    }, [assetId, userid, fuelSetupOpen, dispatch])

    /*useEffect(() => {
        //console.log("loaded fset", fuelSetup);
    }, [fuelSetup])*/




    return (
        <Modal
            open={fuelSetupOpen}
            onClose={handleFuelSetupClose}
        >
            <div style={dimention.fuelAdminModal}>
                <Paper>
                    <div style={{ margin: '10px' }}>
                        <Grid container spacing={2}>
                            <Grid item container xs={12}>
                                <Grid item xs={8}>
                                    <Typography color="text.primary" variant="h5">
                                        Fuel System Setup
                                    </Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="h5">
                                        <span style={{ color: 'DodgerBlue' }}>{regn}</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                            </Grid>
                            <Grid item container xs={12} spacing={1}>
                                <Grid item xs={4}>
                                    <div style={{ margin: '10px' }}>
                                        <FuelLeftColumn fuelSetup={fuelSetup} assetId={assetId} assetData={assetData} />
                                    </div>
                                </Grid>
                                <Grid item xs={8}>
                                    <div style={{ margin: '10px' }}>
                                        <FuelRightColumn fuelSetup={fuelSetup} assetId={assetId} assetData={assetData} />
                                    </div>
                                </Grid>

                            </Grid>
                        </Grid>
                    </div>
                </Paper>
            </div>
        </Modal>
    )
}

export default FuelMainModal;